import api from './api';

const settingsService = {
  getSettings: async () => {
    const response = await api.get('/api/settings');
    return response.data;
  },

  updateSettings: async (data) => {
    const response = await api.put('/api/settings', data);
    return response.data;
  },
};

export default settingsService;